import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AgendaService {

  constructor(private _http: HttpClient) {}

  public VerEmpresas(){
    return this._http.get(`${environment.api}agenda-personal/empresas`);
  }

  public VerAreas(){
    return this._http.get(`${environment.api}agenda-personal/areas`);
  }

  public VerDependencias(area){
    return this._http.get(`${environment.api}agenda-personal/dependencia/${area}`);
  }

  public VerUsuarios(area, dependencia){
    return this._http.get(`${environment.api}agenda-personal/usuarios/${area}/${dependencia}`);
  }

  public AgregarEvento(form){
    return this._http.post(`${environment.api}agenda-personal/add-evento`, form);
  }

  public VerEventos(){
    return this._http.get(`${environment.api}agenda-personal/eventos`);
  }


}

